// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#filter-block{margin-bottom:20px}#filter-block .title{font-size:16px;font-family:\"HelveticaNeueCyr-Bold\",\"Helvetica\",sans-serif;background-color:#E6EFFC;padding:10px 20px;margin:0 -20px 20px -20px}\n", ""]);
// Exports
module.exports = exports;
